import { useEffect } from "react";
import { useSession } from "./useSession";

export const useDynatrace = (url) => {
    const { read, update } = useSession();

    useEffect(() => {
        setTimeout(() => {
            console.log("enterAction", url || window.location.pathname);
            if (!!window.dtrum) {
                try {
                    const id = window.dtrum.enterAction("customPageview", null, null, url || window.location.pathname);
                    update("dynId", id);
                } catch (error) {
                    console.log(error);
                }
            }
        }, 100);

        return () => {
            console.log("leaveAction", read("dynId"));
            if (!!window.dtrum) {
                try {
                    window.dtrum.leaveAction(read("dynId"));
                } catch (error) {
                    console.log(error);
                }
            }
        };
    }, []);

    return {};
};
